<h1 class="flex justify-between"><span>Manage Scholarship</span><span>School Year: <span>{{schoolYear | schoolYear}}</span></span></h1>
<mat-divider></mat-divider>
<p>
    Select finalists and winners for this scholarship using the checkboxes in the table.
    It will save automatically on each click.
    You can also add a student manually.
    Click the 'View Finalist Details' button to view application details (including course work) for all selected finalists.
</p>

<div class="w-fit mt-[20px] mx-auto">
    <h2 class="text-orange-400">{{scholarshipInfo?.ScholarshipName}}</h2>
    <p class="max-w-[800px]">{{scholarshipInfo?.Description}}</p>
    <div class="flex justify-between mb-[20px]">
        <div>Min GPA: <strong class="text-orange-400">{{scholarshipInfo?.MinGPA}}</strong></div>
        <div>Min SAT: <strong class="text-orange-400">{{scholarshipInfo?.MinSAT}}</strong></div>
        <div>Min ACT: <strong class="text-orange-400">{{scholarshipInfo?.MinACT}}</strong></div>
        <div>Min CLT: <strong class="text-orange-400">{{scholarshipInfo?.MinCLT}}</strong></div>
        <div>Min CS Hours: <strong class="text-orange-400">{{scholarshipInfo?.MinCsHours}}</strong></div>
        <div>Min Work Hours: <strong class="text-orange-400">{{scholarshipInfo?.MinWorkHours}}</strong></div>
    </div>
    <div>Schools:</div>
    @for (sch of scholarshipInfo?.Schools; track sch) {
    <div class="my-[10px]"><strong class="text-orange-400">{{sch}}</strong></div>
    }

    <table mat-table [dataSource]="dataSource" matSort matSortDisableClear="true">
        <ng-container matColumnDef="SchoolNumber">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>School #</th>
            <td mat-cell *matCellDef="let row">{{row.SchoolNumber}}</td>
        </ng-container>
        <ng-container matColumnDef="Name">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Name</th>
            <td mat-cell *matCellDef="let row">{{row.Name}}</td>
        </ng-container>
        <ng-container matColumnDef="GPA">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>GPA</th>
            <td mat-cell *matCellDef="let row">{{row.GPA}}</td>
        </ng-container>
        <ng-container matColumnDef="SAT">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>SAT</th>
            <td mat-cell *matCellDef="let row">{{row.SAT}}</td>
        </ng-container>
        <ng-container matColumnDef="ACT">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>ACT</th>
            <td mat-cell *matCellDef="let row">{{row.ACT}}</td>
        </ng-container>
        <ng-container matColumnDef="CLT">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>CLT</th>
            <td mat-cell *matCellDef="let row">{{row.CLT}}</td>
        </ng-container>
        <ng-container matColumnDef="CsHours">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>CsHours</th>
            <td mat-cell *matCellDef="let row">{{row.CsHours}}</td>
        </ng-container>
        <ng-container matColumnDef="WorkHours">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>WorkHours</th>
            <td mat-cell *matCellDef="let row">{{row.WorkHours}}</td>
        </ng-container>
        <ng-container matColumnDef="Finalist">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Finalist</th>
            <td mat-cell *matCellDef="let row">
                @if (row.Disqualified === true) {
                <span>Disqualified</span>
                }
                @else {
                <mat-checkbox [checked]="row.Finalist" (change)="onClick(row.AppID, false)" matTooltip="Mark student as scholarship finalist"></mat-checkbox>
                }
            </td>
        </ng-container>
        <ng-container matColumnDef="Awarded">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Awarded</th>
            <td mat-cell *matCellDef="let row">
                @if (row.Disqualified === false) {
                <mat-checkbox [checked]="row.Awarded" (change)="onClick(row.AppID, true)" matTooltip="Mark student as scholarship winner"></mat-checkbox>
                }
            </td>
        </ng-container>
        <ng-container matColumnDef="Action">
            <th mat-header-cell *matHeaderCellDef>Action</th>
            <td mat-cell *matCellDef="let row">
                <div>
                    <button mat-raised-button type="button" (click)="downloadPDF(row)" class="p-[2px] min-w-0 h-[30px]" matTooltip="Download application summary"><mat-icon class="m-0">download</mat-icon></button>
                </div>
            </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; let even = even; columns: displayedColumns;" [ngClass]="{ evenRows: even, disqualified: row.Disqualified }"></tr>
        <tr class="mat-row" *matNoDataRow>
            <td class="mat-cell text-red-500 text-center" colspan="8">No data found</td>
        </tr>
    </table>
    <div class="flex justify-between mt-[20px]">
        <button mat-raised-button routerLink="/scholarship-count">Back</button>
        <button mat-raised-button (click)="addStudent()" [disabled]="availableStudents == null || availableStudents.length === 0">Add Student</button>
        <button mat-raised-button routerLink="/multi-summary-wrapper/{{scholarshipID}}" [disabled]="anyFinalists === false">View Finalist Summaries</button>
        <button mat-raised-button (click)="finalistDetails()" [disabled]="anyFinalists === false">Download Finalist Summaries</button>
    </div>
</div>